import {LitElement, html, css, svg} from 'lit';
import {customElement, property} from 'lit/decorators.js';

@customElement('obi-alarm-trigger-google')
export class ObiAlarmTriggerGoogle extends LitElement {
  @property({type: Boolean}) useCssColor = false;

  private icon = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
<path d="M2 9.99995C2 8.33329 2.37083 6.80412 3.1125 5.41245C3.85417 4.02078 4.85 2.86662 6.1 1.94995L7.275 3.54995C6.275 4.28328 5.47917 5.20828 4.8875 6.32495C4.29583 7.44162 4 8.66662 4 9.99995H2ZM20 9.99995C20 8.66662 19.7042 7.44162 19.1125 6.32495C18.5208 5.20828 17.725 4.28328 16.725 3.54995L17.9 1.94995C19.15 2.86662 20.1458 4.02078 20.8875 5.41245C21.6292 6.80412 22 8.33329 22 9.99995H20ZM4 19V17H6V9.99995C6 8.61662 6.41667 7.38745 7.25 6.31245C8.08333 5.23745 9.16667 4.53328 10.5 4.19995V3.49995C10.5 3.08328 10.6458 2.72912 10.9375 2.43745C11.2292 2.14578 11.5833 1.99995 12 1.99995C12.4167 1.99995 12.7708 2.14578 13.0625 2.43745C13.3542 2.72912 13.5 3.08328 13.5 3.49995V4.19995C14.8333 4.53328 15.9167 5.23745 16.75 6.31245C17.5833 7.38745 18 8.61662 18 9.99995V17H20V19H4ZM12 22C11.45 22 10.9792 21.8041 10.5875 21.4125C10.1958 21.0208 10 20.55 10 20H14C14 20.55 13.8042 21.0208 13.4125 21.4125C13.0208 21.8041 12.55 22 12 22ZM8 17H16V9.99995C16 8.89995 15.6083 7.95828 14.825 7.17495C14.0417 6.39162 13.1 5.99995 12 5.99995C10.9 5.99995 9.95833 6.39162 9.175 7.17495C8.39167 7.95828 8 8.89995 8 9.99995V17Z" fill="currentColor"/>
</svg>
`;

  private iconCss = svg`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M2 9.99995C2 8.33329 2.37083 6.80412 3.1125 5.41245C3.85417 4.02078 4.85 2.86662 6.1 1.94995L7.275 3.54995C6.275 4.28328 5.47917 5.20828 4.8875 6.32495C4.29583 7.44162 4 8.66662 4 9.99995H2ZM20 9.99995C20 8.66662 19.7042 7.44162 19.1125 6.32495C18.5208 5.20828 17.725 4.28328 16.725 3.54995L17.9 1.94995C19.15 2.86662 20.1458 4.02078 20.8875 5.41245C21.6292 6.80412 22 8.33329 22 9.99995H20ZM4 19V17H6V9.99995C6 8.61662 6.41667 7.38745 7.25 6.31245C8.08333 5.23745 9.16667 4.53328 10.5 4.19995V3.49995C10.5 3.08328 10.6458 2.72912 10.9375 2.43745C11.2292 2.14578 11.5833 1.99995 12 1.99995C12.4167 1.99995 12.7708 2.14578 13.0625 2.43745C13.3542 2.72912 13.5 3.08328 13.5 3.49995V4.19995C14.8333 4.53328 15.9167 5.23745 16.75 6.31245C17.5833 7.38745 18 8.61662 18 9.99995V17H20V19H4ZM12 22C11.45 22 10.9792 21.8041 10.5875 21.4125C10.1958 21.0208 10 20.55 10 20H14C14 20.55 13.8042 21.0208 13.4125 21.4125C13.0208 21.8041 12.55 22 12 22ZM8 17H16V9.99995C16 8.89995 15.6083 7.95828 14.825 7.17495C14.0417 6.39162 13.1 5.99995 12 5.99995C10.9 5.99995 9.95833 6.39162 9.175 7.17495C8.39167 7.95828 8 8.89995 8 9.99995V17Z" style="fill: var(--element-active-color)"/>
</svg>
`;

  override render() {
    return html`
      <div class="wrapper">${this.useCssColor ? this.iconCss : this.icon}</div>
    `;
  }

  static override styles = css`
    .wrapper {
      height: 100%;
      width: 100%;
      line-height: 0;
    }
    .wrapper > * {
      height: 100%;
      width: 100%;
    }
  `;
}

declare global {
  interface HTMLElementTagNameMap {
    'obi-alarm-trigger-google': ObiAlarmTriggerGoogle;
  }
}
